import React from 'react'

export const FlagSv: React.SFC = () => (
  <span>🇸🇪</span>
)

export const FlagEn: React.SFC= () => (
  <span>🇬🇧</span>
)
